import { IBreadcrumb } from '../../types/project/breadcrumbs';
import { IApplicationState } from '../../types/redux';

export const selectBreadcrumbs = (state: IApplicationState): IBreadcrumb[] => {
  return state.projectData.breadcrumbs;
};
